import React from 'react';


export default ({color, style}) => {
  return (
    <svg style={style || {}} xmlns="http://www.w3.org/2000/svg" width="7.999" height="14.001" viewBox="0 0 7.999 14.001">
      <path fill={color || '#202a38'} d="M13.709.292a1,1,0,0,0-1.414,0L7,5.586,1.707.293a1.024,1.024,0,0,0-1.413,0,1,1,0,0,0,0,1.414l6,6a1,1,0,0,0,1.414,0l6-6A1,1,0,0,0,13.709.292Z" transform="translate(0 14.001) rotate(-90)"/>
    </svg>
  )
}